"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var OptionImage = _styledComponents["default"].img.withConfig({
  displayName: "OptionImage",
  componentId: "sc-l6aooq-0"
})(["width:20px;height:20px;min-width:20px;max-width:20px;min-height:20px;max-height:20px;margin-left:5px;"]);

var _default = OptionImage;
exports["default"] = _default;